import axios from 'axios';
import React, { useEffect, useState, memo } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useIsMounted from '../../hooks/useIsMounted.jsx';
import './TOS.scss';

const TOS = ({ language }) => {
  const [tos, setTos] = useState(null);
  const [loading, setLoading] = useState(true);
  const isMountedComponent = useIsMounted();
  const { t } = useTranslation();

  useEffect(() => {
    axios.get('/api/v1/static/tos')
      .then(({ data }) => {
        if (isMountedComponent) {
          const $data = $(data);
          const content = $data.find('section .container .row').html()
            || $data.find('.content.container').html()
            || data;
          if (content) {
            setTos(content);
          }
        }
      }).finally(() => {
        if (isMountedComponent) {
          setLoading(false);
        }
      });
  }, [language]);

  return <Container id="terms-of-service">
    {loading ?
      <Card className="empty mt-2">
        {t('common.loading')}...
      </Card> :
      <span dangerouslySetInnerHTML={{ __html: tos }} />
    }
  </Container>;
}

export default memo(TOS);
